/* ===========================================================================
   MAVELY BOOT  v2   (MV119)  —  v1, but the dashboard-only files wait for a
                                 dashboard
   ===========================================================================
   v1 loaded every <script type="text/mv-idle"> tag on the first idle moment
   after the page loaded — for EVERY visitor. Six of the seven are Link Ledger
   Dashboard tools (Trusted Links, Real Images upload, Switch Link marks,
   Add Subdomain, the Download Button panel, Switch Link Working With All
   Links). On a visitor who has never signed in they did nothing useful, but
   they still ran: measured on a copy of the site, mavely-realimages-admin
   alone spent 1.8 s of main-thread time walking the page looking for a
   dashboard that was not there, and mavely-switchmark asked
   /api/admin/switch-sync every few seconds and logged a 401 each time — the
   "Browser errors were logged to the console" line in the report.

   NOW: a tag marked  data-mv-admin  is loaded only when there is an admin —
   exactly the signals mavely-perf already uses for the dashboard scripts:

     - the address is an admin route (/admin, /dashboard, #admin)
     - this browser holds a saved sign-in (localStorage sh_admin_token)
     - someone signs in on this page (the token appears), or
     - the Link Ledger Dashboard is on screen

   The last two are checked every 1.5 s with one localStorage read and one
   look at the headings — no MutationObserver, no reading the whole page.
   Every other mv-idle tag (the copy toast) loads exactly as in v1.

   Same files, same order (async=false keeps it), same globals. When the
   admin set does load it loads all together, in the order of the tags.

   ROLLING BACK: point index.html at mavely-boot.v1.min.js — it ignores
   data-mv-admin and loads everything as before.

   Console: __mvBoot()
   ========================================================================= */
(function () {
  'use strict';

  if (window.__mvBootLoaded) return;
  window.__mvBootLoaded = true;

  var BACKSTOP_MS = 6000;
  var ADMIN_POLL_MS = 1500;
  var started = false, adminStarted = false, adminTimer = null;
  var stats = { trigger: '', count: 0, at: 0, files: [], adminTrigger: '', adminFiles: [] };

  function collect(admin) {
    var out = [];
    try {
      var tags = document.querySelectorAll('script[type="text/mv-idle"][data-src]');
      for (var i = 0; i < tags.length; i++) {
        var isAdmin = tags[i].hasAttribute('data-mv-admin');
        if (isAdmin !== admin) continue;
        var src = tags[i].getAttribute('data-src');
        if (src) out.push(src);
      }
    } catch (e) {}
    return out;
  }

  function inject(list) {
    for (var i = 0; i < list.length; i++) {
      try {
        if (document.querySelector('script[src="' + list[i] + '"]')) continue;
        var s = document.createElement('script');
        s.src = list[i];
        s.async = false;          // keeps the relative order of the tags
        s.defer = false;
        document.head.appendChild(s);
      } catch (e) { /* one bad tag must not stop the rest */ }
    }
  }

  function now() { return Math.round((window.performance && performance.now) ? performance.now() : 0); }

  /* ---- the public set (v1's behaviour, minus the admin files) ---------- */
  function run(why) {
    if (started) return;
    started = true;
    stats.trigger = why;
    stats.at = now();
    var list = collect(false);
    stats.count = list.length;
    stats.files = list.slice(0);
    inject(list);
    if (isAdmin()) runAdmin('with the public set: ' + adminReason());
  }

  /* ---- the admin set ---------------------------------------------------- */
  function hasToken() {
    try { return !!window.localStorage.getItem('sh_admin_token'); } catch (e) { return false; }
  }
  function adminPath() {
    var p = String(location.pathname || '').toLowerCase();
    return p.indexOf('/admin') === 0 || p.indexOf('/dashboard') === 0 ||
           String(location.hash || '').toLowerCase().indexOf('admin') !== -1;
  }
  /* Read once, now: the app rewrites the address (/admin -> / while it shows
     the sign-in) before the idle moment comes, and the route must still
     count as an admin visit when it does. */
  var adminAtStart = adminPath();
  function dashboardShown() {
    try {
      var hs = document.querySelectorAll('h1, h2, h3');
      for (var i = 0; i < hs.length; i++) {
        if (String(hs[i].textContent || '').indexOf('Link Ledger') !== -1) return true;
      }
    } catch (e) {}
    return false;
  }
  function adminReason() {
    if (adminAtStart || adminPath()) return 'admin route';
    if (hasToken()) return 'saved sign-in';
    if (dashboardShown()) return 'dashboard on screen';
    return '';
  }
  function isAdmin() { return adminReason() !== ''; }

  function runAdmin(why) {
    if (adminStarted) return;
    adminStarted = true;
    if (adminTimer) { window.clearInterval(adminTimer); adminTimer = null; }
    stats.adminTrigger = why;
    var list = collect(true);
    stats.adminFiles = list.slice(0);
    inject(list);
  }

  function watchAdmin() {
    if (adminStarted) return;
    if (isAdmin() && started) { runAdmin(adminReason()); return; }
    /* Watched in every other case — including an admin route before the
       public set has gone, which used to return here without a watch, so a
       sign-in on that page never brought the dashboard tools in. */
    adminTimer = window.setInterval(function () {
      if (adminStarted) { window.clearInterval(adminTimer); adminTimer = null; return; }
      var why = adminReason();
      if (why) {
        /* An admin appeared (signed in, or the dashboard opened): the public
           set first if it has not gone yet, then the admin set. */
        if (!started) run('admin: ' + why);
        runAdmin(why);
      }
    }, ADMIN_POLL_MS);
  }

  /* ---- 1. interaction, which always wins -------------------------------- */
  var EVENTS = ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'wheel'];
  function onInteract() {
    for (var i = 0; i < EVENTS.length; i++) {
      try { window.removeEventListener(EVENTS[i], onInteract, true); } catch (e) {}
    }
    run('interaction');
  }
  for (var i = 0; i < EVENTS.length; i++) {
    try { window.addEventListener(EVENTS[i], onInteract, { capture: true, passive: true }); }
    catch (e) { try { window.addEventListener(EVENTS[i], onInteract, true); } catch (e2) {} }
  }

  /* ---- 2. idle, after load ---------------------------------------------- */
  function afterLoad() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () { run('idle'); }, { timeout: 2500 });
    } else {
      window.setTimeout(function () { run('load'); }, 200);
    }
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });

  /* ---- 3. the backstop --------------------------------------------------- */
  window.setTimeout(function () { run('backstop'); }, BACKSTOP_MS);

  /* ---- 4. the admin watch ------------------------------------------------ */
  watchAdmin();

  window.__mvBoot = function () {
    return {
      started: started,
      trigger: stats.trigger,
      loadedAtMs: stats.at,
      count: stats.count,
      files: stats.files.slice(0),
      adminLoaded: adminStarted,
      adminTrigger: stats.adminTrigger,
      adminFiles: stats.adminFiles.slice(0),
      /* Force everything immediately. Here for support, nothing calls it. */
      now: function () { run('manual'); runAdmin('manual'); }
    };
  };
})();
